const FAST_MAX_MS = 300
const NORMAL_MAX_MS = 1000

// Coarse level instead of a number: some endpoints are cached, so exact values would mislead
export const getLatencyLevel = latencyMs => {
	if (latencyMs < FAST_MAX_MS) return 'fast'
	if (latencyMs < NORMAL_MAX_MS) return 'normal'
	return 'slow'
}

export const LATENCY_LABELS = {
	fast: 'Быстро',
	normal: 'Средне',
	slow: 'Медленно',
}
